import ImageOne from "../images/img.jpg";
import ImageTwo from "../images/new6.jpg";
import ImageThree from "../images/ok1.jpg";
import ImageFour from "../images/table.jpg";

export const SliderData = [
    {
        name: "Urban Design",
        to: "/galery",
        image: ImageOne,
    },
    {
        name: "Interior Design",
        to: "/galery",
        image: ImageTwo,
    },
    {
        name: "Branding",
        to: "/galery",
        image: ImageThree,
    },
    {
        name: "Landscape",
        to: "/galery",
        image: ImageFour,
    },
];
